import {
  CONTRACT_SETUP_ALL_STATE_CLEAR,
  CONTRACT_SETUP_BY_DRAFT_SUCCESS,
  CONTRACT_SETUP_EXPIRATION_DATE_CHANGE,
} from '@app/store/actionTypes';
import { ContractSetupAction } from '@app/store/contract-setup/actions';

type ContractSetupExpirationDateState = number;

const initialState: ContractSetupExpirationDateState = 14;

export default function reducer(
  state: ContractSetupExpirationDateState = initialState,
  action: ContractSetupAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return initialState;
    case CONTRACT_SETUP_EXPIRATION_DATE_CHANGE:
      return action.payload;
    case CONTRACT_SETUP_BY_DRAFT_SUCCESS: {
      const { participants } = action.payload;
      if (participants.length > 0) {
        // 분 단위로 되어있는 signingDuration을 일 단위로 변환합니다.
        // 음수거나 1일 미만일때는 1일로 바꿉니다.
        return Math.max(Math.round(participants[0].signingDuration / (24 * 60)), 1);
      }

      return state;
    }
    default:
      return state;
  }
}
